import axios from "axios";
import Swal from "sweetalert2";

const getEncodedPaymentParams = async ({
  orderIds = [],
  customerId,
  API_BASE_URL,
  token,
}) => {
  const encodedOrderIds = encodeURIComponent(btoa(orderIds.join(",")));
  const encodedOrderType = encodeURIComponent(btoa("cart"));
  const encodedCustomerId = encodeURIComponent(btoa(customerId?.toString() || ""));

  const tempAmountsFetchedResponse = await Promise.all(
    orderIds.map((id) =>
      axios.get(`${API_BASE_URL}/temp-sales-order/id/${id}`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
    )
  );

  const allOrders = tempAmountsFetchedResponse.map((res) => res.data.data);

  const totalAmount = allOrders.reduce((sum, order) => {
    const amount = order?.totalAmount || 0;
    return sum + parseFloat(amount);
  }, 0);

  const encodedTotalAmounts = encodeURIComponent(
    btoa( parseFloat(totalAmount).toFixed(2).toString())
  );

  return {
    encodedOrderIds,
    encodedOrderType,
    encodedCustomerId,
    encodedTotalAmounts,
    totalAmount
  };
};

export const generateApplePayLinkForTempOrders = async ({ orderIds = [], customerId, API_BASE_URL, token, navigate, t = (x) => x }) => {
  if (!Array.isArray(orderIds) || orderIds.length === 0) {
    Swal.fire({
      icon: "error",
      title: t("Payment Link Error"),
      text: t("No valid order IDs were provided."),
      confirmButtonText: t("OK"),
    });
    return;
  }

  try {
    const {
      encodedOrderIds,
      encodedOrderType,
      encodedCustomerId,
      encodedTotalAmounts,
    } = await getEncodedPaymentParams({ orderIds, customerId, API_BASE_URL, token });

    navigate(
      `/apple-pay/${encodedOrderIds}/${encodedTotalAmounts}/${encodedCustomerId}/${encodedOrderType}`
    );
  } catch (error) {
    console.error("Error generating Apple Pay link for temp orders:", error);
    Swal.fire({
      icon: "error",
      title: t("Payment Link Error"),
      text: t("Failed to generate payment link. Please try again."),
      confirmButtonText: t("OK"),
    });
  }
};

export const generateCardPaymentLinkForTempOrders = async ({ orderIds = [], customerId, API_BASE_URL, token, navigate, t = (x) => x, }) => {
  if (!Array.isArray(orderIds) || orderIds.length === 0) {
    Swal.fire({
      icon: "error",
      title: t("Payment Link Error"),
      text: t("No valid order IDs were provided."),
      confirmButtonText: t("OK"),
    });
    return;
  }

  try {
    const {
      encodedOrderIds,
      encodedOrderType,
      encodedCustomerId,
      encodedTotalAmounts,
    } = await getEncodedPaymentParams({ orderIds, customerId, API_BASE_URL, token });
    navigate(
      `/tapcard/${encodedOrderIds}/${encodedTotalAmounts}/${encodedCustomerId}/${encodedOrderType}`
    );
  } catch (error) {
    console.error("Error generating card payment link for temp orders:", error);
    Swal.fire({
      icon: "error",
      title: t("Payment Link Error"),
      text: t("Failed to generate payment link. Please try again."),
      confirmButtonText: t("OK"),
    });
  }
};

export const generateBankTransactionLinkForTempOrders = async ({ orderIds = [], customerId, API_BASE_URL, token, navigate, t = (x) => x, }) => {
  if (!Array.isArray(orderIds) || orderIds.length === 0) {
    Swal.fire({
      icon: "error",
      title: t("Payment Link Error"),
      text: t("No valid order IDs were provided."),
      confirmButtonText: t("OK"),
    });
    return;
  }

  try {
    const {
      totalAmount
    } = await getEncodedPaymentParams({ orderIds, customerId, API_BASE_URL, token });
    const { data } = await axios.post(
      `${API_BASE_URL}/generatePayment-link`,
      {
        id: orderIds,
        endPoint: "bankTransactions/order",
        amount: parseFloat(totalAmount).toFixed(2),
      },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    const extracted = data?.details?.url?.split('/bankTransactions')[1]
    navigate(`/bankTransactions${extracted}`);
  } catch (error) {
    console.error("Error generating bank transaction link for temp orders:", error);
    Swal.fire({
      icon: "error",
      title: t("Payment Link Error"),
      text: t("Failed to generate payment link. Please try again."),
      confirmButtonText: t("OK"),
    });
  }
};